import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  selectJustInCollection,
  selectPetCollection,
  selectSpecialCollection,
} from "../../redux/shop/shop.selectors";

import useStyles from "./nav-for-mobile.styles";
import Drawer from "@material-ui/core/Drawer";

import ShopByBrandMenu from "../shop-by-brand-menu";

import HamburgerIcon from "../../assets/icons/hamburger-icon";
import CloseIcon from "../../assets/icons/close-icon";
import ArrowRightIcon from "../../assets/icons/arrow-right-icon";
import ArrowLeftIcon from "../../assets/icons/arrow-left-icon";

const Divider = () => {
  const classes = useStyles();

  return <div className={classes.divider} />;
};

const EachDrawer = ({
  collections,
  closeFnArr,
  closeAll,
  closeCurrentDrawer,
  previousTitle,
  previousId,
}: {
  collections: any[];
  closeFnArr: any[];
  closeAll: any;
  closeCurrentDrawer: any;
  previousTitle: string;
  previousId?: string;
}) => {
  const classes = useStyles();

  return (
    <div className={classes.drawerContainer}>
      <button
        onClick={closeCurrentDrawer}
        className={`${classes.generalBtn} ${classes.previousBtn}`}
      >
        <ArrowLeftIcon width="42" fill="#ff8c93" />
        {previousTitle}
      </button>
      <Divider />
      {previousId ? (
        <React.Fragment>
          <Link
            to={`/shop?collectionId=${previousId}`}
            onClick={closeAll}
            className={classes.link}
          >
            ALL
            <ArrowRightIcon width="42" />
          </Link>
          <Divider />
        </React.Fragment>
      ) : null}
      {collections.map((collection) => (
        <React.Fragment key={collection.id}>
          <InfiniteDrawer
            collection={collection}
            closeFnArr={closeFnArr}
            closeAll={closeAll}
          />
          <Divider />
        </React.Fragment>
      ))}
    </div>
  );
};

const InfiniteDrawer = ({
  collection,
  closeFnArr,
  closeAll,
}: {
  collection: any;
  closeFnArr: any[];
  closeAll: any;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openDrawer = () => {
    setIsOpen(true);
  };

  const closeDrawer = () => {
    setIsOpen(false);
  };

  closeFnArr.push(closeDrawer);

  const classes = useStyles();

  return (
    <div>
      {collection.collections.length === 0 ? (
        <Link
          to={`/shop?collectionId=${collection.id}`}
          className={classes.link}
          onClick={closeAll}
        >
          {collection.title}
          <ArrowRightIcon width="42" />
        </Link>
      ) : collection.parentCollectionList.length !== 0 ? (
        <button
          onClick={openDrawer}
          className={`${classes.generalBtn} ${classes.btnInDrawer}`}
        >
          {collection.title}
          <ArrowRightIcon width="42" />
        </button>
      ) : (
        <button
          onClick={openDrawer}
          className={`${classes.generalBtn} ${classes.btnInDrawer}`}
        >
          Shop by Pet
          <ArrowRightIcon width="42" />
        </button>
      )}
      <Drawer anchor="right" open={isOpen} onClose={closeAll}>
        {collection.parentCollectionList.length !== 0 ? (
          <EachDrawer
            collections={collection.collections}
            closeFnArr={closeFnArr}
            closeAll={closeAll}
            closeCurrentDrawer={closeDrawer}
            previousTitle={collection.title}
            previousId={collection.id}
          />
        ) : (
          <EachDrawer
            collections={collection.collections}
            closeFnArr={closeFnArr}
            closeAll={closeAll}
            closeCurrentDrawer={closeDrawer}
            previousTitle={"Shop by Pet"}
          />
        )}
        <a
          href="https://become-partner.petobe.ca/"
          onClick={closeAll}
          className={classes.becomeParterLink}
        >
          Become a Partner
        </a>
        <button
          onClick={closeAll}
          className={`${classes.generalBtn} ${classes.closeBtn}`}
        >
          <CloseIcon width="30" />
        </button>
      </Drawer>
    </div>
  );
};

const ShopByPetForMobile = ({ closeNav }: { closeNav: any }) => {
  const petCollection = useSelector(selectPetCollection);

  const closeFnArr: any[] = [];

  closeFnArr.push(closeNav);

  const closeAll = () => {
    closeFnArr.forEach((fn) => fn());
  };

  const classes = useStyles();

  return (
    <div className={classes.linkContainer}>
      <InfiniteDrawer
        collection={petCollection}
        closeFnArr={closeFnArr}
        closeAll={closeAll}
      />
    </div>
  );
};

const ShopByBrandForMobile = ({ closeNav }: { closeNav: any }) => {
  const [isOpen, setIsOpen] = useState(false);

  const classes = useStyles();

  const openDrawer = () => {
    setIsOpen(true);
  };

  const closeDrawer = () => {
    setIsOpen(false);
  };

  const closeFnArr = [closeNav, closeDrawer];

  const closeAll = () => {
    closeFnArr.forEach((fn) => fn());
  };

  return (
    <div>
      <button
        onClick={openDrawer}
        className={`${classes.generalBtn} ${classes.btnInDrawer}`}
      >
        Shop by Brand
        <ArrowRightIcon width="42" />
      </button>
      <Drawer anchor="right" open={isOpen} onClose={closeDrawer}>
        <ShopByBrandMenu closeDrawer={closeDrawer} closeAll={closeAll} />
      </Drawer>
    </div>
  );
};

const NavForMobile = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openNav = () => {
    setIsOpen(true);
  };

  const closeNav = () => {
    setIsOpen(false);
  };

  const justInCollection = useSelector(selectJustInCollection);
  const specialCollection = useSelector(selectSpecialCollection);

  const classes = useStyles();

  const NavContent = () => (
    <div className={classes.navContainer}>
      <div className={classes.linkContainer}>
        <Link
          to={`/shop?collectionId=${justInCollection.collectionId}`}
          onClick={closeNav}
          className={classes.link}
        >
          Just In
          <ArrowRightIcon width="42" />
        </Link>
      </div>
      <ShopByPetForMobile closeNav={closeNav} />
      <ShopByBrandForMobile closeNav={closeNav} />
      <div className={classes.linkContainer}>
        <Link
          to={`/shop?collectionId=${specialCollection.collectionId}`}
          onClick={closeNav}
          className={classes.link}
        >
          Special
          <ArrowRightIcon width="42" />
        </Link>
      </div>
      <div className={classes.linkContainer}>
        <Link to="/" onClick={closeNav} className={classes.link}>
          Pet Service
          <ArrowRightIcon width="42" />
        </Link>
      </div>
      <a
        href="https://become-partner.petobe.ca/"
        onClick={closeNav}
        className={classes.becomeParterLink}
      >
        Become a Partner
      </a>
      <button
        onClick={closeNav}
        className={`${classes.generalBtn} ${classes.closeBtn}`}
      >
        <CloseIcon width="30" />
      </button>
    </div>
  );

  return (
    <div>
      <button onClick={openNav} className={classes.generalBtn}>
        <HamburgerIcon width="36" height="36" />
      </button>
      <Drawer anchor="right" open={isOpen} onClose={closeNav}>
        {NavContent()}
      </Drawer>
    </div>
  );
};

export default NavForMobile;
